import React from "react";
import { Link, useNavigate } from "react-router-dom";
import supabase from "../supabaseClient";
import "../components/Layout.css";

const Layout = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/");
  };

  return (
    <div className="app-container">
      <aside className="sidebar">
        <div>
          <div className="sidebar-header">
            <h2>CarWash Pro</h2>
            <p className="sidebar-subtitle">Operator Panel</p>
          </div>
          <nav className="sidebar-nav">
            <Link to="/dashboard" className="nav-link">
              <span className="nav-icon">🏠</span>
              <span className="nav-text">Dashboard</span>
            </Link>
            <Link to="/log" className="nav-link">
              <span className="nav-icon">📋</span>
              <span className="nav-text">Check-In Log</span>
            </Link>
            <Link to="/settings" className="nav-link">
              <span className="nav-icon">⚙️</span>
              <span className="nav-text">Settings</span>
            </Link>
          </nav>
        </div>
        <div className="logout-container">
          <button onClick={handleLogout} className="logout-button">
            <span className="nav-icon">🚪</span>
            <span className="nav-text">Logout</span>
          </button>
        </div>
      </aside>
      <main className="main-content">{children}</main>
    </div>
  );
};

export default Layout;
